import { QuestionRatingComponent } from './question-rating.component';

export default angular
  .module('sfMobile.components.question-rating', [
    'sfMobile.constants.form-question-actions',
    'sfMobile.components.rating',
  ])
  .component('questionRating', QuestionRatingComponent).name;
